import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';

import HomePage from './pages/HomePage';
import TemplatePage from './pages/smart_templates/TemplatePage'; // универсальный шаблон

function PrivateRoute({ children }) {
  const isLoggedIn = !!localStorage.getItem('access_token');
  const location = useLocation();
  if (!isLoggedIn) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }
  return children;
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />

        {/* Один универсальный маршрут с параметром */}
        <Route
          path="/smart_templates/:templateId"
          element={
            <PrivateRoute>
              <TemplatePage />
            </PrivateRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;